/** @format */

import React from "react";
import PlayStore from "../assets/Playstore.svg";
import AppleStore from "../assets/Applestore.svg";
// import MobileApps from "../assets/MobileApps.svg";
import MobileAppsPNG from "../assets/MobileApps.png";

const DownloadFitStats = () => {
  return (
    <div
      className="bg-[#FDF7FF] xl:px-24 px-8 pt-[70px] "
      id="download-fit-stats"
    >
      <div className="flex md:flex-row flex-col md:space-y-0 space-y-20 justify-center items-center">
        <div className="sm:w-[90%] m-auto">
          <h2 className="download-fit-stats-title text-[48px] leading-[65.47px] tracking-[-2%] text-black opacity-80 font-extrabold w-full">
            DOWNLOAD <span className="text-[#710B95]">FIT</span>
            <span className="text-[#0CC6D3]">STATS</span>
          </h2>
          <p className="text-[20px] leading-[35.38px] tracking-[-2%] text-black opacity-80 lg:w-[80%]">
            Start working toward your dream body, one day at a time. Download
            the FitStats app, sign up, and execute simple and engaging workouts.
          </p>
          <div className="flex sm:flex-row flex-col sm:space-x-12 space-x-0 sm:space-y-0 space-y-6 mt-[23px]">
            <img
              src={PlayStore}
              alt="play-store"
              className="cursor-pointer sm:w-auto w-[50%]"
            />
            <img
              src={AppleStore}
              alt="apple-store"
              className="cursor-pointer sm:w-auto w-[50%]"
            />
          </div>
        </div>
        <div className="w-full">
          <img src={MobileAppsPNG} alt="mobile-apps" className="" />
        </div>
      </div>
    </div>
  );
};

export default DownloadFitStats;
